import { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase.js'

// Pulls the menu-kill candidates view. Returns kill candidates first,
// then the rest of the catalog so the manager can see context (where
// the dogs sit relative to bestsellers).
//
// View is RLS-scoped, so the SELECT will only return rows for the
// signed-in tenant.
export function useMenuKillCandidates() {
  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  async function load() {
    setLoading(true)
    setError(null)
    try {
      const { data, error: dbErr } = await supabase
        .from('vw_menu_kill_candidates')
        .select('*')
        // Kill candidates first (true sorts after false in Postgres
        // ascending, so we do desc), then by units ascending so the
        // worst sellers float to the top of each bucket.
        .order('is_kill_candidate', { ascending: false })
        .order('units_90d', { ascending: true })
      if (dbErr) throw dbErr
      setRows(data || [])
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('[useMenuKillCandidates] load failed', e)
      setError(e?.message || 'Could not load menu data.')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => { load() }, [])

  // Convenience derived values for the UI
  const candidates = rows.filter((r) => r.is_kill_candidate)
  const survivors  = rows.filter((r) => !r.is_kill_candidate)

  return { rows, candidates, survivors, loading, error, refresh: load }
}
